import FileReaderProvider, { FileReaderButton } from '../FileReader/FileReader';
import { Alert, Grid } from '@mui/material';
import AppFile from '../../../../models/AppFile';
import RequestFileRow from '../RequestFilesContainer/RequestFileRow/RequestFileRow';
import { useTranslation } from 'react-i18next';

const RequestDocuments = ({
  studenDocuments,
  editFiles,
  toSort,
  addFile,
  removeFile,
  files,
  isEditFile,
  getMaxSize,
}: {
  studenDocuments: AppFile[];
  editFiles: boolean,
  toSort: (documents: AppFile[] | undefined) => AppFile[] | undefined,
  addFile: (file: AppFile) => void,
  removeFile: (documentID: string) => void,
  files: AppFile[],
  isEditFile: boolean,
  getMaxSize: (document: AppFile) => string,
}) => {
  const { t } = useTranslation();
  

  return (
    <Grid
      container
      direction='row'
      spacing={2}
      alignItems='center'
      justifyContent='flex-start'
      wrap='wrap'
      sx={{ padding: '25px 0 25px 15px' }}
    >
      {editFiles &&
        <Alert sx={{ margin: '0 0 1rem 0', width: '100%' }} severity='warning'>
          {t('fileAlert')}
        </Alert>
      }
      <Grid
        container
        item
        spacing={2}
        wrap='wrap'
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          marginBottom: '5px'
        }}
      >
        {editFiles ? (
          toSort(studenDocuments)?.map((document, index) => {
            return (
              <Grid
                item
                key={document.id}
                xs={12}
                sm={6}
                md='auto'
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  gap: '10px'
                }}
              >
                <RequestFileRow
                  documentId={document.id}
                  url={document.url}
                  title={document.file_type}
                  documentName={document.file_name}
                  addFile={addFile}
                  removeFile={removeFile}
                  canUpdate={isEditFile}
                  isLast={index === studenDocuments.length - 1}
                  documentType={document.file_type}
                  maxSize={getMaxSize(document)}
                  documents={document}
                />
              </Grid>
            );
          })
        ) : (
          <FileReaderProvider>
            {files?.map((file: { file_name: string }) => (
              <FileReaderButton
                key={file?.file_name}
                file={file}
                variant={'outlined'}
              />
            ))}
          </FileReaderProvider>
        )}
      </Grid>
    </Grid>
  );
};

RequestDocuments.propTypes = {};

export default RequestDocuments;
